const { trackGtm, trackGtm4 } = require('util/functions');
const asyncImport = require('util/asyncImport').default;

const CLASS_BOX_LINK = '.box-article-content--link';
const CLASS_BOX_TITLE = '.box-article-content--title';
const CLASS_DOWNLOAD_LINK = '.topic-highlight--download-link';
const CLASS_DOWLAD_LABEL = '.topic-highlight--download-label';
const CLASS_WARNING = '.banner-widget--warning';
const CLASS_CLOSE = '.banner-widget--close';
const CLASS_HIGHLIGHT = '.highlight';
const CLASS_TOPIC_HIGHLIGHT = '.topic-highlight';

module.exports = {
	async init() {
		await asyncImport(this, 'debounce');
		this.root
			.querySelector(CLASS_CLOSE)
			?.addEventListener('click', this.hideWarning.bind(this));
		const highlights = this.root.querySelectorAll(CLASS_HIGHLIGHT);

		highlights.forEach(element => {
			element.addEventListener('click', () => {
				// type casting to get boolean

				const isDownloadable = element.dataset.downloadable === 'true';
				trackGtm(this.determineTrackedObject(element, isDownloadable, false));
				trackGtm4(this.determineTrackedObject(element, isDownloadable, true));
			});
		});

		this.isMobileVideo = !!this.root.dataset.mobileVideo;
		this.isDesktopVideo = !!this.root.dataset.desktopVideo;
		this.updateVideoSource();

		if (this.isDesktopVideo || this.isMobileVideo) {
			this.currentVideoUrl =
				window.innerWidth < 768
					? this.root.dataset.mobileVideo
					: this.root.dataset.desktopVideo;
			window.addEventListener(
				'resize',
				this.debounce(this.updateVideoSource.bind(this), 100),
			);
		}
	},
	determineTrackedObject(link, isDownloadable, gtm4) {
		let trackedObject = {};
		let trackedObjectGtm4 = {};
		const downloadButtonStyleChange = !!this.root.dataset.downloadStyleChange;
		const linkHref = link.querySelector(CLASS_BOX_LINK)?.href;

		if (isDownloadable) {
			const widgetTitle = this.root
				.querySelector(CLASS_BOX_TITLE)
				.textContent.trim();
			const elementLinkText =
				link.querySelector(CLASS_DOWLAD_LABEL).textContent;
			const downloadLink = downloadButtonStyleChange
				? link.querySelector(CLASS_DOWNLOAD_LINK).href
				: linkHref;
			const titleText = link
				.querySelector(
					downloadButtonStyleChange ? CLASS_DOWNLOAD_LINK : CLASS_BOX_TITLE,
				)
				.textContent.trim();
			const label = `${titleText} / ${downloadLink}`;

			trackedObject = {
				eventCategory: 'outgoing tracking',
				eventAction: 'download',
				eventLabel: label,
			};
			trackedObjectGtm4 = {
				event: 'GA4_event_c_file_download',
				file_name: downloadLink.split('/').pop(),
				widget_name: this.getParentWidgetName(),
				widget_title: widgetTitle,
				link_url: downloadLink,
				link_text: elementLinkText,
				title: titleText,
			};

			const gtmObject = gtm4 ? trackedObjectGtm4 : trackedObject;
			trackedObject = gtmObject;
		} else {
			trackedObject = {
				eventCategory: 'cta',
				eventAction: 'image',
				eventLabel: linkHref,
			};
		}

		return trackedObject;
	},
	getParentWidgetName() {
		const dataSelector = this.root
			.querySelector(CLASS_TOPIC_HIGHLIGHT)
			.getAttribute('data-parent');
		return dataSelector ? dataSelector : '';
	},
	hideWarning() {
		this.root.querySelector(CLASS_WARNING).style.display = 'none';
	},

	updateVideoSource() {
		const isWideScreen = window.innerWidth >= 768;
		const video = this.root.querySelector('video');
		const videoSource = video?.querySelector('source');
		const videoUrl =
			!isWideScreen && videoSource
				? this.root.dataset.mobileVideo
				: this.root.dataset.desktopVideo;

		if (video) {
			video.style.display =
				(this.isMobileVideo && !this.isDesktopVideo && isWideScreen) ||
				(!this.isMobileVideo && this.isDesktopVideo && !isWideScreen)
					? 'none'
					: 'block';
		}

		if (videoUrl !== this.currentVideoUrl && videoSource) {
			videoSource.src = videoUrl;
			this.currentVideoUrl = videoUrl;
			video?.load();
		}
	},
};
